import {Component, Input, OnInit} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {ParticipantOverview} from 'src/app/calibration/_interfaces/participant-overview.interface';
import {BaseClass} from 'src/app/shared/classes/base';
import {AiSummaryService} from 'src/app/shared/services/ai-summary.service';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {BulletPoint, OriginProcessType, UserSummaryData} from '../models/userSummaryData';
import {GeneralValuationData} from '../models/generalValuationData';

@Component({
    selector: 'app-ai-summary-content',
    templateUrl: './ai-summary-content.component.html',
    styleUrls: ['./ai-summary-content.component.scss'],
})
export class AiSummaryContentComponent extends BaseClass implements OnInit {
    @Input() public participant: Partial<ParticipantOverview>;
    @Input() public cycleParticipantId: number;
    @Input() public isExportMode: boolean = false;

    public summaryAiData: UserSummaryData;
    public aiThreeSixtyAndFreeBulletPointsData: BulletPoint[];
    public aiThreeSixtyLeadershipBulletPointsData: BulletPoint[];
    public managementLeadershipDataTable: GeneralValuationData[];
    public threeSixtySummaryText: string;
    public freeSummaryText: string;
    public threeSixtyLeadershipText: string;

    public pageCount: number = 2;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        protected _aiSummaryService: AiSummaryService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.getAiGeneralSummaryData();
    }

    private async getAiGeneralSummaryData() {
        const cycleParticipantId = this.cycleParticipantId;
        this._aiSummaryService.getReviewsAiUserSummary(cycleParticipantId).subscribe((data) => {
            this.summaryAiData = data.data;
            this.extractSumaryData(this.summaryAiData);
        }, (error) => {
            this.notifyError(error);
        });
    }

    private extractSumaryData(summary: UserSummaryData) {

        this.threeSixtySummaryText = summary['360'].summary_line_manager;
        const threeSixtyBulletPoints = summary['360'].bullet_points;
        threeSixtyBulletPoints.forEach(p => p.process_type = OriginProcessType.ThreeSixtyEvaluation);

        this.freeSummaryText = summary.free.summary_line_manager;
        const freeBulletPoints = summary.free.bullet_points;
        freeBulletPoints.forEach(p => p.process_type = OriginProcessType.FreeEvaluation);

        this.aiThreeSixtyAndFreeBulletPointsData = [...threeSixtyBulletPoints, ...freeBulletPoints];

        this.threeSixtyLeadershipText = summary.leadership.summary_line_manager;
        const threeSixtyLeadershipBulletPoints = summary.leadership.bullet_points;
        threeSixtyLeadershipBulletPoints.forEach(p => p.process_type = OriginProcessType.Leadership);

        this.aiThreeSixtyLeadershipBulletPointsData = threeSixtyLeadershipBulletPoints;

        if (this.threeSixtyLeadershipText) {
            this.pageCount = 4;
        }
    }
}
